import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_BYTES = 10 * 1024 * 1024;
const ALLOWED = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

// Downscale + re-encode on the client so mobile uploads stay fast.
export const compress = (file, maxSide = 1600, quality = 0.82) => new Promise((resolve) => {
  if (!['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type) || file.size < 120 * 1024) return resolve(file);
  const img = new Image();
  const url = URL.createObjectURL(file);
  img.onload = () => {
    const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    canvas.toBlob((blob) => {
      URL.revokeObjectURL(url);
      resolve(blob && blob.size < file.size ? new File([blob], file.name.replace(/\.\w+$/, '.jpg'), { type: 'image/jpeg' }) : file);
    }, 'image/jpeg', quality);
  };
  img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
  img.src = url;
});

export const uploadImage = async (file, folder = 'misc', onProgress) => {
  if (!ALLOWED.includes(file.type)) throw new Error('Formato no válido. Usa JPG, PNG, WebP o HEIC');
  if (file.size > MAX_BYTES) throw new Error('La imagen supera los 10 MB');
  const ready = await compress(file);
  const form = new FormData();
  form.append('file', ready, ready.name || 'foto.jpg');
  const { data } = await axios.post(`${API}/uploads?folder=${folder}`, form, {
    onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
  });
  return data.url;
};

// Admin ad videos: MP4/WebM/MOV, max 20MB, ~30s (checked client-side, no server transcoding).
const VIDEO_ALLOWED = ['video/mp4', 'video/webm', 'video/quicktime'];
const MAX_VIDEO_BYTES = 20 * 1024 * 1024;
const MAX_VIDEO_SECONDS = 32;

const videoDuration = (file) => new Promise((resolve) => {
  const url = URL.createObjectURL(file);
  const v = document.createElement('video');
  v.preload = 'metadata';
  v.onloadedmetadata = () => { URL.revokeObjectURL(url); resolve(v.duration || 0); };
  v.onerror = () => { URL.revokeObjectURL(url); resolve(0); };
  v.src = url;
});

export const uploadVideo = async (file, folder = 'ads', onProgress) => {
  if (!VIDEO_ALLOWED.includes(file.type)) throw new Error('Formato no válido. Usa MP4, WebM o MOV');
  if (file.size > MAX_VIDEO_BYTES) throw new Error('El video supera los 20 MB');
  const dur = await videoDuration(file);
  if (dur > MAX_VIDEO_SECONDS) throw new Error('El video debe durar 30 segundos o menos');
  const form = new FormData();
  form.append('file', file, file.name || 'video.mp4');
  const { data } = await axios.post(`${API}/uploads?folder=${folder}`, form, {
    onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
  });
  return data.url;
};
